import type { ReactNode } from 'react'

type CollapsibleSectionProps = {
  label: string
  count?: number
  collapsed: boolean
  onToggle: () => void
  children: ReactNode
  className?: string
}

/**
 * Reusable collapsible section with arrow toggle and optional count
 */
export function CollapsibleSection({
  label,
  count,
  collapsed,
  onToggle,
  children,
  className = ''
}: CollapsibleSectionProps) {
  return (
    <div className={className}>
      <button
        onClick={onToggle}
        className="w-full flex items-center gap-1.5 text-xs font-semibold text-gray-400 uppercase tracking-wider py-2 hover:text-gray-600"
      >
        <span className={`transition-transform text-[10px] ${collapsed ? '' : 'rotate-90'}`}>
          ▶
        </span>
        {label}
        {count !== undefined && ` (${count})`}
      </button>
      {!collapsed && children}
    </div>
  )
}
